export const AGGREGATOR_REPORTS_REQUESTED = 'AGGREGATOR_REPORTS_REQUESTED';
export const AGGREGATOR_REPORTS_SUCCESS = 'AGGREGATOR_REPORTS_SUCCESS';
export const AGGREGATOR_REPORTS_FAILED = 'AGGREGATOR_REPORTS_FAILED';
